import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import type { VideoMaxAdDurationTargetingType } from '@openx/types/targeting/targetingValuesTypes.ts';
import { type JSX, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getMaxAdDurationOptions, getOptionKeys } from '../../../utils/utils.ts';

type TypeDropdownProps = {
  targetingType: VideoMaxAdDurationTargetingType;
  setTargetingType: (type: VideoMaxAdDurationTargetingType) => void;
};

export const TypeDropdown = ({ setTargetingType, targetingType }: TypeDropdownProps): JSX.Element => {
  const { t } = useTranslation();

  const onChange = useCallback(
    (_event, value: VideoMaxAdDurationTargetingType) => {
      setTargetingType(value);
    },
    [setTargetingType]
  );

  const optionTypeLabels = useMemo(() => getMaxAdDurationOptions(t), [t]);

  return (
    <AutoComplete
      options={getOptionKeys(optionTypeLabels)}
      getOptionLabel={option => optionTypeLabels[option].name}
      value={targetingType}
      onChange={onChange}
      disableClearable
      textFieldReadOnly
      fullWidth
      textFieldProps={{
        label: t('Maximum Ad Duration'),
      }}
      data-test="max-ad-duration-type-dropdown"
    />
  );
};
